module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-2-985a0ab4d7defe4a901c4795d52df3fd.jpg";